import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import firebase from "firebase/compat";
import CurrentUserDetailsPresenter from "@/components/CurrentUserDetailsPresenter.vue";

type Props = {
  // signInCB: CallableFunction;
  loggedIn: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AppBarView',
  props: {
    loggedIn: { type: Boolean }
  },
  emits: ["titlePressed", "signInPressed", "signOutPressed"],
  setup(__props: any, { emit: emits }) {





const titleTextPressed = () => {
  emits("titlePressed");
};

const signInTilePressed = () => {
  console.log("Signing in...");
  emits("signInPressed");
};

const signOutTilePressed = () => {
  console.log("Signing out...");
  emits("signOutPressed");
};

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, { dense: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_img, {
        src: require('../../assets/logo_dark.png'),
        "max-width": "56",
        onclick: titleTextPressed,
        class: "clickable mb-4 mt-4 ml-4"
      }, null, 8, ["src"]),
      _createVNode(_component_v_app_bar_title, {
        onclick: titleTextPressed,
        class: "clickable"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Hnefatafl")
        ]),
        _: 1
      }),
      _createVNode(CurrentUserDetailsPresenter),
      _createVNode(_component_v_spacer),
      (!__props.loggedIn)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            depressed: "",
            elevation: "2",
            color: "primary",
            onClick: signInTilePressed
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Log in ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.loggedIn)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            depressed: "",
            elevation: "2",
            color: "primary",
            onClick: signOutTilePressed
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Log out ")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})